import { FunctionComponent } from 'react';
import styles from './SelectorHeader.module.scss';
import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/pro-light-svg-icons/faChevronDown';
import { faChevronUp } from '@fortawesome/pro-light-svg-icons/faChevronUp';
import isEmpty from 'lodash/isEmpty';

interface SelectorHeaderProps {
    placeholder?: string;
    selectedLabel?: string;
    expanded: boolean;
    className?: string;
    onClick?: () => void;
}

const getLabel = (selectedLabel?: string, placeholder?: string) => {
    if (!isEmpty(selectedLabel)) {
        return selectedLabel;
    } else if (!isEmpty(placeholder)) {
        return placeholder;
    } else {
        return 'Select';
    }
};

export const SelectorHeader: FunctionComponent<SelectorHeaderProps> = props => {
    const label = getLabel(props.selectedLabel, props.placeholder);

    return (
        <div
            className={clsx(styles.container, { [styles.expanded]: props.expanded }, props.className)}
            onClick={props.onClick}
        >
            <div className={styles.right}>
                <span className={styles.label}>{label}</span>
            </div>
            <div className={styles.left}>
                <FontAwesomeIcon icon={props.expanded ? faChevronUp : faChevronDown} />
            </div>
        </div>
    );
};

export default SelectorHeader;
